import { render } from "./ListeDemandePrix.vue?vue&type=template&id=2a3bf178&ts=true"
import script from "./ListeDemandePrix.vue?vue&type=script&lang=ts"
export * from "./ListeDemandePrix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__